const initState = {
  loading: false,
  points: 0,
  err: "",
};

export const TournamentPointsReducer = (state = initState, action) => {
  switch (action.type) {
    case "TOURNAMENT_POINTS_LOADING":
      return {
        ...state,
        loading: true,
        err: "",
      };

    case "TOURNAMENT_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
        points: action.points ?? 0,
        err: "",
      };

    case "TOURNAMENT_POINTS_ERROR":
      return {
        ...state,
        loading: false,
        err: action.error || "",
      };

    default:
      return state;
  }
};
